import { Icon, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import styles from './documents-required-label.module.scss';
import clsx from 'clsx';
import { InstructionTabProps } from 'modules/case-tracking/types/documents-required/documents-required.types';

const DocumentsRequiredLabel = ({ isDocumentsRequired, isCancelled }: InstructionTabProps) => {
  if (isCancelled) {
    return <>Documents required</>;
  }

  return (
    <>
      Documents required
      {isDocumentsRequired ? (
        <Icon className={clsx([styles.icon, styles.alert])} icon={ICONS_ENUM.ALERT_WARNING} />
      ) : (
        <Icon
          className={clsx([styles.icon, styles.success])}
          icon={ICONS_ENUM.ACTION_CHECK_CIRCLE}
        />
      )}
    </>
  );
};

export default DocumentsRequiredLabel;
